import { render } from "./BankBalance.vue?vue&type=template&id=256ddd86"
import script from "./BankBalance.vue?vue&type=script&lang=js"
export * from "./BankBalance.vue?vue&type=script&lang=js"

import "./BankBalance.vue?vue&type=style&index=0&id=256ddd86&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/BankBalance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "256ddd86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('256ddd86', __exports__)) {
    api.reload('256ddd86', __exports__)
  }
  
  module.hot.accept("./BankBalance.vue?vue&type=template&id=256ddd86", () => {
    api.rerender('256ddd86', render)
  })

}


export default __exports__